<template>
  <FooterSocial
    :title="mgnlProps.title"
    :social-links="socialLinks"
    :seal-images="sealImages"
    :show-column-kiosk="mgnlProps.showColumnKiosk"
    :show-column-catalog="mgnlProps.showColumnCatalog"
  />
</template>

<script lang="ts" setup>
import FooterSocial from '~/components/Footer/FooterSocial/FooterSocial.vue';
import { FooterSocialBuilder, WrapperProps } from '~/components/Footer/FooterSocial/FooterSocial.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const { $domain } = useNuxtApp();
const props = defineProps(WrapperProps);
const mgnlProps = FooterSocialBuilder.build(props);

const socialLinks = computed(() => (
  mgnlProps.socialLinks?.map(social => ({
    src: magnoliaGetters.getDefaultSrcAsset(social.image, $domain.cmsAssetDomainPath),
    srcSet: social.image ? magnoliaGetters.getSrcSetImagesAsString(social.image, $domain.cmsAssetDomainPath, social.aspectRatio, social.mobileAspectRatio?.[0]?.aspectRatio) : [],
    link: magnoliaGetters.getLinkAndName(social, $domain.cmsAssetDomainPath),
  }))
));

const sealImages = computed(() => (
  mgnlProps.sealImages?.map(seal => ({
    src: magnoliaGetters.getDefaultSrcAsset(seal.image, $domain.cmsAssetDomainPath),
    srcSet: seal.image ? magnoliaGetters.getSrcSetImagesAsString(seal.image, $domain.cmsAssetDomainPath, seal.aspectRatio, seal.mobileAspectRatio?.[0]?.aspectRatio) : [],
    alt: magnoliaGetters.getAltImage(seal.image, seal.alt),
    link: seal.sealLink?.[0] ? magnoliaGetters.getLinkAndName(seal.sealLink[0], $domain.cmsAssetDomainPath) : {},
  }))
));
</script>
